var BreakdownController = (function () {
    function BreakdownController(topic, $state, $scope, socket, env, Dialog, notify) {
        var _this = this;
        this.topic = topic;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.Dialog = Dialog;
        this.notify = notify;
        this.visible = true;
        this.isRemoveButtonVisible = false;
        this.isRefreshButtonVisible = false;
        //used to show processing bar while server call is performed
        this.isProcessing = false;
        // this field is used in esc-button-section
        // it is taken from vm.topic.editableComponents.calculation.editMode
        this.edit = { editable: false };
        // also used in esc-button-section, do not change name and value
        this.comp = 'calculation';
        this.isRemoveButtonVisible = this.topic.topic.status.status_no === 4
            && [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.topic.status.sub_status_no) < 0
            && this.env.user.access.systemAdmin;
        this.isRefreshButtonVisible = this.topic.calculation ? !this.topic.calculation.complete : false;
        this.edit = this.topic.getEditComponent(BreakdownController.COMPONENT_NAME);
        this.socket.forward(BreakdownController.TOPIC_SAVE, this.$scope);
        this.$scope.$on("socket:" + BreakdownController.TOPIC_SAVE, function (event, data) {
            _this.isProcessing = false;
            _this.edit.editMode = _this.topic.cancelEdit(BreakdownController.COMPONENT_NAME);
            // used in esc button logic
            _this.topic.updatePartialSocketStatus([_this.comp], '');
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            if (data.error) {
                _this.notify.error(data.error);
            }
            else {
                _this.topic.calculation = data.calculation;
                _this.notify.success("Calculation was updated successfully");
            }
            return;
        });
        this.socket.forward(BreakdownController.TOPIC_RECALCULATE, this.$scope);
        this.$scope.$on("socket:" + BreakdownController.TOPIC_RECALCULATE, function (event, data) {
            _this.topic.temp.calculation = data.calculation;
            _this.isProcessing = false;
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            if (data.error) {
                _this.notify.error(data.error);
            }
            else {
                _this.topic.requireRecalculation = false;
                _this.topic.changed = true;
                _this.notify.success("Recalculated successfully - Remember to Save your changes");
            }
            return;
        });
        this.socket.forward(BreakdownController.TOPIC_REVERT_V2, this.$scope);
        this.$scope.$on("socket:" + BreakdownController.TOPIC_REVERT_V2, function (event, data) {
            _this.isProcessing = false;
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            if (data.error) {
                _this.notify.error(data.error);
            }
            // } else {
            //     this.notify.success(`Reverted successfully`);
            // }
            return;
        });
    }
    BreakdownController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    BreakdownController.prototype.getErrors = function () {
        return this.topic.editableComponents.calculation.editMode ?
            this.topic.temp.calculation.errors.errorList.join('\n') :
            this.topic.calculation.errors.errorList.join('\n');
    };
    BreakdownController.prototype.isError = function () {
        return this.topic.editableComponents.calculation.editMode ?
            this.topic.temp.calculation.errors.errorList.length :
            this.topic.calculation.errors.errorList.length;
    };
    BreakdownController.prototype.showRefreshSaveCalculationError = function () {
        var dialogData = {
            icon: 'ERROR',
            message: 'You need to refresh after doing any changes. &nbsp;Click the Refresh button.',
            title: 'Saving Error'
        };
        // do nothing after confirmation button is pressed
        this.Dialog.updateValidForm(undefined, dialogData, BreakdownController.CONFIRM_PROMT);
    };
    BreakdownController.prototype.showChangedSaveCalculationError = function () {
        var dialogData = {
            icon: 'ERROR',
            message: 'No changes were done, nothing to save.',
            title: 'Saving Error'
        };
        // do nothing after confirmation button is pressed
        this.Dialog.updateValidForm(undefined, dialogData, BreakdownController.CONFIRM_PROMT);
    };
    BreakdownController.prototype.showValidationError = function (errorMessage) {
        var dialogData = {
            icon: 'ERROR',
            message: errorMessage,
            title: 'Edit Error'
        };
        // do nothing after confirmation button is pressed
        this.Dialog.updateValidForm(undefined, dialogData, BreakdownController.CONFIRM_PROMT);
    };
    BreakdownController.prototype.checkRevertCondition = function () {
        return this.topic.topic.status.status_no === 4 &&
            [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.topic.status.sub_status_no) >= 0 &&
            (this.env.user.access.bpsoAdmin || this.env.user.access.systemAdmin);
    };
    BreakdownController.prototype.revertStatus = function () {
        var _this = this;
        if (this.isProcessing) {
            return;
        }
        var items = {
            icon: 'QUESTION',
            message: 'Use this function to revert back to a <b>Pending BPSO</b> status and edit the Calculations again.',
            title: 'Revert from Set Aside'
        };
        // If already approved, warn this will wipe the approvals
        if (this.topic.topic.status.approvals.complete) {
            items.message +=
                '<br><br><b style="color:red">NOTE:</b> &nbsp;Should you choose to continue, the' +
                    ' Approvals already granted will be wiped and the Disbursement will need to go through the Approval Process again.';
        }
        items.message += '<br><br>Are you sure?';
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        className: BreakdownController.BACKEND_CLASS,
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calculcation: _this.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'revertStatus',
                        script: BreakdownController.BACKEND_MODULE,
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    BreakdownController.prototype.validateEdit = function () {
        var errorMessage;
        if (!this.topic.temp.calculation.drpgs.length) {
            return 'Calculation should have at least one brand family';
        }
        // gather all ids to check uniqueness
        var drpgsIds = new Set();
        var pnIds = new Set();
        var lnIds = new Set();
        for (var _i = 0, _a = this.topic.temp.calculation.drpgs; _i < _a.length; _i++) {
            var drpg = _a[_i];
            if (drpgsIds.has(drpg.id)) {
                errorMessage = "Drpg id duplicate found: " + drpg.id + ". Ids should not be duplicated.";
            }
            else {
                errorMessage = this.validateDrpg(drpg);
            }
            if (errorMessage) {
                return errorMessage;
            }
            drpgsIds.add(drpg.id);
            for (var _b = 0, _c = drpg.partNumbers; _b < _c.length; _b++) {
                var partNumber = _c[_b];
                if (pnIds.has(partNumber.id)) {
                    errorMessage = "Part number id duplicate found. Drpg: " + drpg.id + ", part number: " + partNumber.id + ". Ids should not be duplicated.";
                }
                else {
                    errorMessage = this.validatePartNumber(partNumber);
                }
                if (errorMessage) {
                    return errorMessage;
                }
                pnIds.add(partNumber.id);
                for (var _d = 0, _e = partNumber.lineItems; _d < _e.length; _d++) {
                    var lineItem = _e[_d];
                    if (lnIds.has(lineItem.id)) {
                        errorMessage = "Line item id duplicate found. Drpg: " + drpg.id + ", part number: " + partNumber.id + ", line item: " + lineItem.id + ". Ids should not be duplicated.";
                    }
                    else {
                        errorMessage = this.validateLineItem(lineItem);
                    }
                    if (errorMessage) {
                        return errorMessage;
                    }
                    lnIds.add(lineItem.id);
                }
            }
        }
    };
    BreakdownController.prototype.validateDrpg = function (drpg) {
        if (!drpg) {
            return 'Brand family is undefined';
        }
        if (!drpg.id) {
            return 'Brand family id should not be empty';
        }
    };
    BreakdownController.prototype.validatePartNumber = function (partNumber) {
        if (!partNumber) {
            return 'Part number is undefined';
        }
        if (!partNumber.id) {
            return 'Part number id should not be empty';
        }
    };
    BreakdownController.prototype.validateLineItem = function (lineItem) {
        if (!lineItem) {
            return 'Line item is undefined';
        }
        if (!lineItem.id) {
            return 'Line item id should not be empty';
        }
        if (lineItem.data.find(function (data) { return !data.extendedPrice; })) {
            return 'Extended price should not be emtpy or 0';
        }
    };
    BreakdownController.prototype.saveCalculation = function () {
        var updateCalculationData = {
            module: {
                className: BreakdownController.BACKEND_CLASS,
                data: {
                    bID: this.topic.topicBrowserID,
                    calculation: this.topic.temp.calculation,
                    oppDocId: this.topic.topic._id
                },
                function: 'saveCalculation',
                script: BreakdownController.BACKEND_MODULE,
                token: this.env.user.token,
                user: this.env.user
            }
        };
        this.isProcessing = true;
        this.socket.emit(BreakdownController.EMIT_OBJECT_NAME, updateCalculationData);
    };
    BreakdownController.prototype.requireRecalculation = function () {
        this.topic.changed = true;
        this.topic.requireRecalculation = true;
    };
    // function that is called on edit/save calculation
    BreakdownController.prototype.changeEditMode = function (action) {
        switch (action) {
            case BreakdownController.ACTION_SAVE: {
                var errorMessage = this.validateEdit();
                if (errorMessage) {
                    this.showValidationError(errorMessage);
                }
                else if (!this.topic.changed) {
                    // do not save if nothing changed
                    this.showChangedSaveCalculationError();
                }
                else if (this.topic.requireRecalculation) {
                    // only save when data is re-calculated after values are changed
                    this.showRefreshSaveCalculationError();
                }
                else if (this.topic.updatePartialSocketStatus([BreakdownController.COMPONENT_NAME], 'Updating')) {
                    // updatePartialSocketStatus checks that no other component is being saved at the moment
                    // also checks that user can perform update at this moment/with his creds/etc
                    // if all is good - update calculation object
                    this.saveCalculation();
                }
                break;
            }
            case BreakdownController.ACTION_EDIT: {
                this.edit.editMode = this.topic.setTempFromCalculationV2();
                break;
            }
            default: {
                this.edit.editMode = this.topic.cancelEdit(BreakdownController.COMPONENT_NAME);
            }
        }
    };
    BreakdownController.prototype.removeCalculation = function () {
        var _this = this;
        var items = {
            icon: 'QUESTION',
            message: 'You are about to permanently delete the Calculations. &nbsp;Are you sure?',
            title: 'Remove Calculations'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit(BreakdownController.EMIT_OBJECT_NAME, {
                    module: {
                        className: BreakdownController.BACKEND_CLASS,
                        data: {
                            bID: _this.topic.topicBrowserID,
                            docId: _this.topic.topic._id
                        },
                        function: 'removeCalculation',
                        script: BreakdownController.BACKEND_MODULE,
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
                _this.$state.go('detail.validation', {
                    id: _this.topic.topic._id.substring(4)
                });
            }
        });
    };
    BreakdownController.prototype.recalculate = function () {
        var errorMessage = this.validateEdit();
        if (errorMessage) {
            this.showValidationError(errorMessage);
            return;
        }
        this.isProcessing = true;
        this.socket.emit(BreakdownController.EMIT_OBJECT_NAME, {
            module: {
                className: BreakdownController.BACKEND_CLASS,
                data: {
                    bID: this.topic.topicBrowserID,
                    calculation: this.topic.temp.calculation,
                    docId: this.topic.topic._id
                },
                function: 'recalculate',
                script: BreakdownController.BACKEND_MODULE,
                token: this.env.user.token,
                user: this.env.user
            }
        });
        return;
    };
    BreakdownController.ACTION_EDIT = 'edit';
    BreakdownController.ACTION_SAVE = 'save';
    BreakdownController.CONFIRM_PROMT = 'confirm-prompt.html';
    BreakdownController.COMPONENT_NAME = 'calculation';
    BreakdownController.BACKEND_MODULE = '/detail/payment/v2/calculate/calculateClient';
    BreakdownController.BACKEND_CLASS = 'CalculateClient';
    //private static TOPIC_UPDATED: string = 'broadcast:topicUpdated';
    BreakdownController.TOPIC_RECALCULATE = 'topic.calculation.recalculate';
    BreakdownController.TOPIC_REVERT_V2 = 'topic.calculation.revertV2';
    BreakdownController.TOPIC_SAVE = 'topic.calculation.save';
    BreakdownController.EMIT_OBJECT_NAME = 'module';
    BreakdownController.$inject = [
        'topic',
        '$state',
        '$scope',
        'socket',
        'env',
        'Dialog',
        'notify',
    ];
    return BreakdownController;
}());
angular
    .module('application')
    .component('paymentBreakdown', new BreakdownComponent());

//# sourceMappingURL=breakdownController.js.map
